export const TextHyphens = {
  NONE: 'none',
  AUTO: 'auto',
  MANUAL: 'manual',
} as const;

export const TextWordBreaks = {
  NORMAL: 'normal',
  ANYWHERE: 'anywhere',
  LONG_WORDS: 'long-words',
} as const;
